export default "__VITE_ASSET__S6UqfG_9__"